<script>
import {
  ArrowUpIcon,
  ChevronRightIcon,
  EyeIcon,
  ArrowRightIcon,
  MonitorIcon,
  HeartIcon,
  CodeIcon,
  UserCheckIcon,
  GitMergeIcon,
  SettingsIcon,
  FeatherIcon,
  BoldIcon,
} from "vue-feather-icons";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import { Carousel, Slide } from "vue-carousel";

import Navbar from "@/components/navbar";
import Footer from "@/components/footer";
import Testimonial from "@/components/testimonial";
import News from "@/components/news";

/**
 * Index component
 */
export default {
  data() {
    return {
      swiperOptions: {
        lazy: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      testimonialData: [
        {
          id: 1,
          profile: "images/client/01.jpg",
          message:
            "It seems that only fragments of the original text remain in the Lorem Ipsum texts used today.",
          name: "Thomas Israel",
          designation: "C.E.O",
        },
        {
          id: 2,
          profile: "images/client/02.jpg",
          message:
            "One disadvantage of Lorum Ipsum is that in Latin certain letters appear more frequently than others.",
          name: "Barbara McIntosh",
          designation: "M.D",
        },
        {
          id: 3,
          profile: "images/client/03.jpg",
          message:
            "The most well-known dummy text is the 'Lorem Ipsum', which is said to have originated in the 16th century.",
          name: "Carl Oliver",
          designation: "P.A",
        },
        {
          id: 4,
          profile: "images/client/04.jpg",
          message:
            "According to most sources, Lorum Ipsum can be traced back to a text composed by Cicero.",
          name: "Christa Smith",
          designation: "Manager",
        },
        {
          id: 5,
          profile: "images/client/05.jpg",
          message:
            "There is now an abundance of readable dummy texts. These are usually used when a text is required.",
          name: "Dean Tolle",
          designation: "Developer",
        },
        {
          id: 6,
          profile: "images/client/05.jpg",
          message:
            "Thus, Lorem Ipsum has only limited suitability as a visual filler for German texts.",
          name: "Jill Webb",
          designation: "Designer",
        },
      ],
    };
  },
  components: {
    Navbar,
    Footer,
    Testimonial,
    News,
    ArrowUpIcon,
    Slide,
    Swiper,
    SwiperSlide,
    EyeIcon,
    ChevronRightIcon,
    ArrowRightIcon,
    HeartIcon,
    CodeIcon,
    UserCheckIcon,
    GitMergeIcon,
    SettingsIcon,
    FeatherIcon,
    MonitorIcon,
    BoldIcon,
  },
  directives: {
    swiper: directive,
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  methods: {
    nextSlide() {
      this.$refs.mySwiper.$swiper.slideNext();
    },
    prevSlide() {
      this.$refs.mySwiper.$swiper.slidePrev();
    },
  },
};
</script>

<template>
  <div>
    <Navbar :nav-light="true" />
    <swiper
      ref="mySwiper"
      class="swiper-slider-hero position-relative d-block vh-100"
      :options="swiperOptions"
    >
      <swiper-slide>
        <div class="swiper-slide d-flex align-items-center overflow-hidden">
          <div
            class="slide-inner slide-bg-image d-flex align-items-center"
            :style="{
              background:
                'url(' +
                require('../../public/images/corporate/2.png') +
                ') center center',
            }"
          >
            <div class="bg-overlay"></div>
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-12">
                  <div class="title-heading text-center">
                    <h1 class="heading text-white title-dark mb-4">
                      Document Support Inc<br />
                      Your Technology Partner
                    </h1>
                    <p class="para-desc mx-auto text-white">
                      More than 15 years of experience providing multifunctional printers, office technology and support solutions in Puerto Rico.
                    </p>

                    <div class="mt-4 pt-2">
                      <router-link to="/contact-us" class="btn btn-primary mt-3">Contact Us </router-link>
                    </div>
                  </div>
                </div>
                <!--end col-->
              </div>
              <!--end row-->
            </div>
            <!--end container-->
          </div>
          <!-- end slide-inner -->
        </div>
        <!-- end swiper-slide -->
      </swiper-slide>
      
      <!-- <div class="swiper-container" slot="pagination">
        <div
          class="swiper-button-next border rounded-circle text-center"
          slot="button-prev"
          @click="nextSlide()"
        ></div>
        <div
          class="swiper-button-prev border rounded-circle text-center"
          slot="button-next"
          @click="prevSlide()"
        ></div>
      </div> -->
    </swiper>

    <!-- FEATURES START -->
    <section class="section bg-light">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="features-absolute">
              <div class="row">
                <div class="col-lg col-md-6 col-12">
                  <div
                    class="card features feature-clean explore-feature p-4 px-md-3 border-0 rounded-md shadow text-center"
                  >
                    <div class="text-center mx-auto">
                      <img src="/images/brands/sharp.png" alt="Sharp" style="max-height: 80px; max-width: 120px;" />
                    </div>

                    <div class="card-body p-0 content">
                      <h5 class="mt-4">
                        <router-link to="/products/sharp" class="title text-dark"
                          >Sharp</router-link
                        >
                      </h5>
                      <p class="text-muted">
                        Award-winning multi-function printers
                      </p>

                      <router-link to="/products/sharp" class="text-primary"
                        >Learn More
                        <chevron-right-icon
                          class="fea icon-sm"
                        ></chevron-right-icon
                      ></router-link>
                    </div>
                  </div>
                </div>
                <!--end col-->

                <div class="col-lg col-md-6 col-12 mt-4 mt-lg-0 pt-2 pt-lg-0">
                  <div
                    class="card features feature-clean explore-feature p-4 px-md-3 border-0 rounded-md shadow text-center"
                  >
                    <div class="text-center mx-auto">
                      <img src="/images/brands/konica.png" alt="Konica Minolta" style="max-height: 80px; max-width: 120px;" />
                    </div>

                    <div class="card-body p-0 content">
                      <h5 class="mt-4">
                        <router-link to="/products/konica-minolta" class="title text-dark"
                          >Konica Minolta</router-link
                        >
                      </h5>
                      <p class="text-muted">
                        Professional printing and imaging solutions
                      </p>

                      <router-link to="/products/konica-minolta" class="text-primary"
                        >Learn More
                        <chevron-right-icon
                          class="fea icon-sm"
                        ></chevron-right-icon
                      ></router-link>
                    </div>
                  </div>
                </div>
                <!--end col-->

                <div class="col-lg col-md-6 col-12 mt-4 mt-lg-0 pt-2 pt-lg-0">
                  <div
                    class="card features feature-clean explore-feature p-4 px-md-3 border-0 rounded-md shadow text-center"
                  >
                    <div class="text-center mx-auto">
                      <img src="/images/brands/lexmark.png" alt="Lexmark" style="max-height: 80px; max-width: 120px;" />
                    </div>

                    <div class="card-body p-0 content">
                      <h5 class="mt-4">
                        <router-link to="/products/lexmark" class="title text-dark"
                          >Lexmark</router-link
                        >
                      </h5>
                      <p class="text-muted">
                        Reliable and efficient printing technology
                      </p>

                      <router-link to="/products/lexmark" class="text-primary"
                        >Learn More
                        <chevron-right-icon
                          class="fea icon-sm"
                        ></chevron-right-icon
                      ></router-link>
                    </div>
                  </div>
                </div>
                <!--end col-->

                <div class="col-lg col-md-6 col-12 mt-4 mt-lg-0 pt-2 pt-lg-0">
                  <div
                    class="card features feature-clean explore-feature p-4 px-md-3 border-0 rounded-md shadow text-center"
                  >
                    <div class="text-center mx-auto">
                      <img src="/images/brands/hp.png" alt="HP" style="max-height: 80px; max-width: 120px;" />
                    </div>

                    <div class="card-body p-0 content">
                      <h5 class="mt-4">
                        <router-link to="/products/hp" class="title text-dark"
                          >HP <span class="badge badge-warning ml-1">Soon</span></router-link
                        >
                      </h5>
                      <p class="text-muted">
                        Coming soon to our product portfolio
                      </p>

                      <router-link to="/products/hp" class="text-primary"
                        >Learn More
                        <chevron-right-icon
                          class="fea icon-sm"
                        ></chevron-right-icon
                      ></router-link>
                    </div>
                  </div>
                </div>
                <!--end col-->

                <div class="col-lg col-md-6 col-12 mt-4 mt-lg-0 pt-2 pt-lg-0">
                  <div
                    class="card features feature-clean explore-feature p-4 px-md-3 border-0 rounded-md shadow text-center"
                  >
                    <div class="text-center mx-auto">
                      <img src="/images/brands/brother.png" alt="Brother" style="max-height: 80px; max-width: 120px;" />
                    </div>

                    <div class="card-body p-0 content">
                      <h5 class="mt-4">
                        <router-link to="/products/brother" class="title text-dark"
                          >Brother <span class="badge badge-warning ml-1">Soon</span></router-link
                        >
                      </h5>
                      <p class="text-muted">
                        Coming soon to our product portfolio
                      </p>

                      <router-link to="/products/brother" class="text-primary"
                        >Learn More
                        <chevron-right-icon
                          class="fea icon-sm"
                        ></chevron-right-icon
                      ></router-link>
                    </div>
                  </div>
                </div>
                <!--end col-->
              </div>
            </div>
          </div>
        </div>
        <!--end row-->
      </div>
      <!--end container-->

      <div class="container mt-100 mt-60">
        <div class="row align-items-center">
          <div class="col-12 mt-4 pt-2 mt-sm-0 pt-sm-0 text-center">
            <div class="section-title">
              <h4 class="title mb-4">
                About Us
              </h4>
              <p class="text-muted mb-3 mx-auto para-desc">
                <span class="text-primary font-weight-bold">Document Support Inc</span> has more than 15 years of experience in Puerto Rico. We specialize in sales of multifunctional printers, laptops, displays, projectors, toners, consumables and service of multifunctional printers.
              </p>
              <p class="text-muted mb-3 mx-auto para-desc">
                We offer different alternatives for your business or company so we can meet your needs. We are distributors of prestigious lines like Sharp, Konica Minolta, Lexmark, HP and Brother is in process. We also sell all brands of consumables and toners for your office or government agency.
              </p>
              <p class="text-muted mx-auto para-desc">
                We provide service and maintenance for our products with the best service technicians.
              </p>
              <router-link to="/contact-us" class="btn btn-primary mt-3"
                >Contact Us <i class="mdi mdi-chevron-right"></i
              ></router-link>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->

    <section class="section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title mb-4 pb-2">
              <h4 class="title mb-4">Our Services</h4>
              <p class="text-muted para-desc mx-auto mb-0">
                <span class="text-primary font-weight-bold">Document Support Inc</span> sells to government agencies and public companies. Our focus is to provide the best products in the market along with excellence of service to meet our client's needs.
              </p>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->

       
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <section class="section bg-light pt-0">
      <div class="container">
        <div class="row justify-content-center mt-5 pt-5">
          <div class="col-12 text-center">
            <div class="section-title mb-4 pb-2">
              <h4 class="title mb-4">Our Service Department</h4>
              <p class="text-muted para-desc mx-auto mb-0">
                Our service department provides quality service and a quick response guarantying the customer's satisfaction.
              </p>
            </div>
          </div>
        </div>
        
      </div>
    </section>
    <!--end section-->
    <Footer />
    <!-- Footer End -->
    <Switcher />
    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>

<style>
.swiper-button-prev::after {
  display: none;
}

.swiper-button-next::after {
  display: none;
}

.modal-content {
  background-color: transparent;
}
</style>
